export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7715.1833e8be.jpg";